// Selectors
import { RootState } from '../../store';


export const globalStateSelector = (state: RootState) => state.globalState

